import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const tab = ({ isActive }) =>
  `font-ui text-sm py-3 border-b-2 transition-colors ${isActive ? "border-[var(--accent)]" : "border-transparent text-[var(--ink-2)] hover:text-[var(--ink)]"}`;

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    if (user) api.get("/admin/unread").then((r) => setUnread(r.data.messages)).catch(() => {});
  }, [user, pathname]);
  if (user === null) return <p className="p-10 meta">Checking session</p>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return (
    <div className="min-h-screen bg-[#F4F4F2]" data-testid="admin-layout">
      <header className="bg-white border-b border-[var(--rule)]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 flex items-center gap-6 sm:gap-8 overflow-x-auto whitespace-nowrap">
          <Link to="/" className="font-display text-xl font-bold py-3" data-testid="admin-view-site-link">
            uk<span className="italic font-medium">discovered</span> <span className="meta ml-2">Admin</span>
          </Link>
          <NavLink end to="/admin" className={tab} data-testid="admin-nav-articles">Articles</NavLink>
          <NavLink to="/admin/visits" className={tab} data-testid="admin-nav-visits">Visits</NavLink>
          <NavLink to="/admin/subscribers" className={tab} data-testid="admin-nav-subscribers">Subscribers</NavLink>
          <NavLink to="/admin/messages" className={tab} data-testid="admin-nav-messages">
            Messages{unread > 0 && <span className="ml-1.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-[var(--accent)] text-white text-[10px] font-semibold" data-testid="admin-unread-badge">{unread}</span>}
          </NavLink>
          <NavLink to="/admin/about" className={tab} data-testid="admin-edit-about-button">About page</NavLink>
          <button onClick={logout} className="ml-auto font-ui text-sm text-[var(--ink-2)] hover:text-[var(--accent)]" data-testid="admin-logout-button">Sign out</button>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10"><Outlet /></div>
    </div>
  );
}
